import { a as e, c as t, i as n, l as r, o as i, s as a, t as o, u as s } from "./editor-video-CKpx_3uk.js";
import { t as c } from "./video-list.selector-Bfdp8SBu.js";
import { defineAsyncComponent as l } from "vue";
import { ROUTES as u } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var d = {
	en: {
		assemblerAissistTranscript: {
			transcriptVideo: "Video transcript",
			resultTitle: "Video transcript",
			formTitle: "Create video transcript",
			sourceChoiceTitle: "Transcript source",
			sourceChoiceHint: "This video already has generated subtitles. Use them as transcript, or generate a new transcript with Aissist.",
			useGeneratedSubtitles: "Use generated subtitles",
			generateWithAissist: "Generate with Aissist",
			subtitlesLoadFailed: "Could not load generated subtitles. Opening Aissist transcript form instead.",
			language: "Language",
			diarization: "Enable speaker recognition",
			numSpeakers: "Number of speakers",
			createArticle: "Create article",
			createArticleForm: {
				formTitle: "Create Video Article",
				articleType: "Article type",
				newsArticle: "BF author",
				newsArticleTooltip: "Article by BF-author without partner logo",
				partnerArticle: "Partner article",
				partnerArticleTooltip: "Partner article with partner logo",
				partnerArticleDisabledTooltip: "A partner article cannot be created from this video as it does not come from any known partner.",
				articleBilling: "Article billing",
				articleIsNotBilled: "Own text (not billed)",
				articleIsBilled: "Partner text (billed)"
			},
			discard: "Discard transcript",
			transcriptText: "Transcript text",
			copyToClipboard: "Copy transcript to clipboard",
			transcriptInProgress: "Video transcription is in progress. Please wait until it is finished.",
			transcriptFailed: "Video transcription failed",
			noLicences: "Aissist transformation is disabled because there are no valid licenses for this video",
			status: {
				NEW: "New",
				SUBMITTED_LOCALLY: "Submitted locally",
				CONVERTING: "Converting",
				CONVERSION_FAILED: "Conversion failed",
				CONVERTED: "Converted",
				UPLOADING_TO_CLOUD: "Uploading to cloud storage",
				UPLOAD_FAILED: "Upload to cloud storage failed",
				UPLOADED: "Uploaded",
				SUBMITTING_TO_PROVIDER: "Submitting to provider",
				SUBMITTED_TO_PROVIDER: "Submitted to provider",
				SUBMITTING_FAILED: "Submitting to provider failed",
				WAITING_FOR_PROVIDER: "Waiting for transcript provider",
				TIMED_OUT: "Timeout",
				RUNNING: "Running",
				SUCCEEDED: "Succeeded",
				FAILED: "Failed",
				TRANSCRIPT_FAILED: "Transcription failed",
				UNKNOWN: "Unknown"
			}
		},
		videos: {
			contentBlockLabel: "Video",
			credit: "Video credit",
			aiGeneratedVideos: "Show AI generated videos only",
			partnerVideos: "Show external partner videos only",
			components: {
				videoSelectorHintInvalid: "Invalid video",
				videoSelectorHintUnknown: "Unknown error",
				uploadVideo: "Upload video",
				editVideo: "Edit video",
				videoSelect: "Select",
				videoSelected: "Selected",
				videoExpiresIn: "Expires in {n} days",
				videoExpired: "Unpublished",
				videoPreviewImageExpired: "Image expired",
				videoExpires: "Unpublish date",
				videoPublish: "Online in {n} days",
				videoUnpublished: "Video not published",
				videoCreated: "Published on",
				videoTitle: "Create article with video",
				videoCredits: "Credit",
				videoStatus: "Status",
				aspectText: "Preview for different video sizes based on the focal point",
				aspectTeaser: "Teaser Home & Channel + Title Video Mobile",
				aspectTitle: "Title video on Tablet & Desktop",
				aspectDesc: "After setting the focal point and saving ,the preview is visible here.",
				aspectClick: "Please focus on the square video.",
				videoDeleted: "Deleted"
			},
			backButton: "To video list",
			title: "Title",
			altText: "Alt text",
			altTextHint: "If not filled in, the title is used.",
			caption: "Caption",
			selectVideo: "Select video",
			addVideo: "Add video",
			removeVideo: "Remove video",
			source: "Credit",
			publishedAt: "Publish date",
			expiredAt: "Unpublish date",
			msn: "MSN service",
			deleteVideo: "Delete video",
			messageConfirmDelete1: "Are you sure you want to delete the video?",
			messageConfirmDelete2: "?",
			messageMandatoryInformation: "This video cannot be saved as mandatory information is missing.",
			messageUpload: "Video uploaded",
			messageSaved: "Video saved",
			messageDeleted: "Video deleted",
			invalid: "Invalid",
			setFocalPoint: "Please set the focal point by clicking on the video.",
			articleLabel: "Article",
			invalidVideoCover: "Unpublished",
			invalidVideoCoverTooltip: "This video has an expired preview image.",
			deletedVideoCover: "Deleted",
			deletedVideoCoverTooltip: "The preview image for this video has been deleted.",
			notAnVideoFile: "The selected file is not a video.",
			license: "License",
			copyXymaticId: "Copy Xymatic ID",
			copyVideoUuid: "Copy video UUID",
			openVideoInXymatic: "Open in Xymatic",
			createVideoPage: "Create video page",
			createVideoArticle: "Create video article",
			transcriptVideo: "Video transcript"
		}
	},
	de: {
		assemblerAissistTranscript: {
			transcriptVideo: "Video-Transkript",
			resultTitle: "Video-Transkript",
			formTitle: "Video-Transkript erstellen",
			sourceChoiceTitle: "Transkript-Quelle",
			sourceChoiceHint: "Für dieses Video liegen bereits generierte Untertitel vor. Diese als Transkript nutzen oder mit Aissist ein neues Transkript erstellen.",
			useGeneratedSubtitles: "Generierte Untertitel verwenden",
			generateWithAissist: "Mit Aissist generieren",
			subtitlesLoadFailed: "Generierte Untertitel konnten nicht geladen werden. Das Aissist-Transkript-Formular wird stattdessen geöffnet.",
			language: "Sprache",
			diarization: "Sprechererkennung aktivieren",
			numSpeakers: "Anzahl der Sprecher",
			createArticle: "Artikel erstellen",
			createArticleForm: {
				formTitle: "Video Artikel erstellen",
				articleType: "Artikel-Typ",
				newsArticle: "BF-Autor",
				newsArticleTooltip: "Artikel von BF-Autor ohne Partner-Logo",
				partnerArticle: "Partner-Artikel",
				partnerArticleTooltip: "Partner-Artikel mit Partner-Logo",
				partnerArticleDisabledTooltip: "Aus diesem Video kann kein Partner-Artikel erstellt werden, da es von keinem bekannten Partner stammt.",
				articleBilling: "Artikel-Abrechnung",
				articleIsNotBilled: "Eigener Text (nicht abgerechnet)",
				articleIsBilled: "Partner-Text (abgerechnet)"
			},
			discard: "Transkript verwerfen",
			transcriptText: "Transkript-Text",
			copyToClipboard: "Transkript in die Zwischenablage kopieren",
			transcriptInProgress: "Das Video-Transkript wird erstellt. Bitte warten, bis es fertig ist.",
			transcriptFailed: "Video-Transkription fehlgeschlagen",
			noLicences: "Die Aissist-Konvertierung ist deaktiviert, da für dieses Video keine gültigen Lizenzen vorliegen",
			status: {
				NEW: "Neu",
				SUBMITTED_LOCALLY: "Lokal eingereicht",
				CONVERTING: "Wird konvertiert",
				CONVERSION_FAILED: "Konvertierung fehlgeschlagen",
				CONVERTED: "Konvertiert",
				UPLOADING_TO_CLOUD: "Wird in Cloud-Speicher hochgeladen",
				UPLOAD_FAILED: "Hochladen in Cloud-Speicher fehlgeschlagen",
				UPLOADED: "Hochgeladen",
				SUBMITTING_TO_PROVIDER: "Wird an Anbieter übermittelt",
				SUBMITTED_TO_PROVIDER: "An Anbieter übermittelt",
				SUBMITTING_FAILED: "Übermittlung an Anbieter fehlgeschlagen",
				WAITING_FOR_PROVIDER: "Warten auf Transkriptanbieter",
				TIMED_OUT: "Zeitüberschreitung",
				RUNNING: "Läuft",
				SUCCEEDED: "Erfolgreich",
				FAILED: "Fehlgeschlagen",
				TRANSCRIPT_FAILED: "Transkription fehlgeschlagen",
				UNKNOWN: "Unbekannt"
			}
		},
		videos: {
			contentBlockLabel: "Video",
			credit: "Video-Credit",
			aiGeneratedVideos: "Nur KI-generierte Videos anzeigen",
			partnerVideos: "Nur Videos externer Partner anzeigen",
			components: {
				videoSelectorHintInvalid: "Ungültiges Video",
				videoSelectorHintUnknown: "Unbekannter Fehler",
				uploadVideo: "Video hochladen",
				editVideo: "Video bearbeiten",
				videoSelect: "Auswählen",
				videoSelected: "Ausgewählt",
				videoExpiresIn: "Läuft in {n} Tagen ab",
				videoPublish: "Online in {n} Tagen",
				videoUnpublished: "Video nicht veröffentlicht",
				videoExpired: "Depubliziert",
				videoPreviewImageExpired: "Bild abgelaufen",
				videoExpires: "Ablaufdatum",
				videoCreated: "Publiziert am",
				videoTitle: "Artikel mit Video erstellen",
				videoCredits: "Credit",
				videoStatus: "Status",
				aspectText: "Vorschau für verschiedene Videogrößen basierend auf dem Fokuspunkt",
				aspectTeaser: "Teaser Home & Channel + Titelbild Mobile",
				aspectTitle: "Titelvideo auf Tablet & Desktop",
				aspectDesc: "Wenn der Fokuspunkt gesetzt und gespeichert ist, wird die Vorschau sichtbar.",
				aspectClick: "Bitte auf das quadratische Bild fokussieren.",
				videoDeleted: "Gelöscht"
			},
			backButton: "Zur Video-Liste",
			title: "Titel",
			altText: "Alt-Text",
			altTextHint: "Wenn nicht befüllt, wird der Titel genutzt.",
			caption: "Bildunterschrift",
			selectVideo: "Video auswählen",
			addVideo: "Video hinzufügen",
			removeVideo: "Video entfernen",
			source: "Credit",
			publishedAt: "Veröffentlichungsdatum (publish date)",
			expiredAt: "Ablaufdatum",
			msn: "MSN-Service",
			deleteVideo: "Video löschen",
			messageConfirmDelete1: "Willst du das Video wirklich löschen?",
			messageConfirmDelete2: "löschen möchtest?",
			messageMandatoryInformation: "Das Video kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			messageUpload: "Video hochgeladen",
			messageSaved: "Video gespeichert",
			messageDeleted: "Video gelöscht",
			invalid: "Ungültig",
			setFocalPoint: "Bitte den Fokuspunkt durch Klicken aufs Video setzen.",
			articleLabel: "Artikel",
			invalidVideoCover: "Depubliziert",
			invalidVideoCoverTooltip: "Das Preview-Bild für dieses Video ist abgelaufen.",
			deletedVideoCover: "Gelöscht",
			deletedVideoCoverTooltip: "Das Vorschau-Bild für dieses Video wurde gelöscht.",
			notAnVideoFile: "Die ausgewählte Datei ist kein Video.",
			license: "Lizenz",
			copyXymaticId: "Xymatic-ID kopieren",
			copyVideoUuid: "Video-UUID kopieren",
			openVideoInXymatic: "In Xymatic öffnen",
			createVideoPage: "Video-Seite erstellen",
			createVideoArticle: "Video-Artikel erstellen",
			transcriptVideo: "Video-Transkript"
		}
	}
}, f = [{
	path: `/${u.videos.path}`,
	meta: { i18RouteTitleKey: u.videos.path },
	children: [{
		path: "",
		name: "video_list",
		component: () => import("./video-list-T3ghh1O1.js"),
		meta: { requiredRight: "videos:navigate" }
	}]
}], p = l(() => import("./video-content-block-BrCO2yq4.js")), m = {
	messages: d,
	routes: f,
	contentBlocks: [{
		type: "VIDEO",
		label: "videos.contentBlockLabel",
		icon: "video",
		component: p,
		defaultValue: i()
	}]
};
//#endregion
export { o as EditorVideo, p as VideoContentBlock, c as VideoListSelector, n as VideoModelName, e as VideoService, i as getDefaultVideoBlock, a as getVideo, t as getVideoByXymaticId, r as getVideoUrl, s as getVideos, m as videoModule };

//# sourceMappingURL=index.es.js.map